import { Injectable } from '@angular/core';

declare var window: any;

@Injectable()
export class PlayerPositionService {

  constructor() { }

  getInnerHeight() {
    return window.innerHeight;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/player-position.service.ts